export default __webpack_public_path__ + "static/media/long.de39e98c.png";